export default __webpack_public_path__ + "static/media/10_Play-a-game-outdoors_Share.c09b3a86.jpg";